export default "__VITE_ASSET__CWKQAa$a__"